import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enquiry-report-menu',
  templateUrl: './enquiry-report-menu.component.html',
  styleUrls: ['./enquiry-report-menu.component.css']
})
export class EnquiryReportMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component.ts